import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTreeComponent } from './project-tree.component';
import {MatTreeModule} from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FuseSharedModule} from '../../../@fuse/shared.module';
import {EntityInfoModule} from '../entity-info/entity-info.module';
import {ProjectTreeService} from './project-tree.service';
import { NewNodeComponent } from './new-node/new-node.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';




@NgModule({
    declarations: [ProjectTreeComponent, NewNodeComponent],
    exports: [
        ProjectTreeComponent
    ],
    imports: [
        CommonModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        FuseSharedModule,
        EntityInfoModule,
        MatFormFieldModule,
        MatInputModule,
        MatToolbarModule,
        MatSelectModule,
        MatDialogModule
    ],
    providers   : [
        ProjectTreeService
    ]
})
export class ProjectTreeModule { }
